import { makeEnv } from "./base"

const { AsyncAlertRoot, asyncAlert } = makeEnv()

export { asyncAlert, AsyncAlertRoot }
